export const stopEventPropagation = (e: React.MouseEvent) => e.stopPropagation();
